import React from "react";

export class CollectionDisposalAddressDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props };
  }

  render() {
    return (
      <>
        {this.props.disposalType === "non_hazardous" && (
          <div className="text-center disposal-location">
            <h1 className="no-margin">Commercial Recycling</h1>
            <p className="no-margin">
              Aston Way, Mannings Heath Road, Poole BH12 4FE
            </p>
          </div>
        )}
        {this.props.disposalType === "hazardous" && (
          <div className="text-center disposal-location">
            <h1 className="no-margin">SRCL Limited</h1>
            <p className="no-margin">
              Royal Bournemouth Hospital, Bournemouth, Dorset, BH7 7DW
            </p>
          </div>
        )}
      </>
    );
  }
}
